import "core-js/modules/es.array.concat.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue";
var _hoisted_1 = {
  class: "vertical-swiper"
};
var _hoisted_2 = ["src", "alt"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_swipe_item = _resolveComponent("van-swipe-item");
  var _component_van_swipe = _resolveComponent("van-swipe");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_swipe, {
    ref: "swipeRef",
    autoplay: $props.autoplay,
    duration: $data.duration,
    vertical: true,
    loop: false,
    "show-indicators": $props.showIndicators,
    "indicator-color": $props.indicatorColor,
    touchable: $data.touchable,
    onChange: $options.onChange,
    class: "swiper-container"
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.displayItems, function (item, index) {
        return _openBlock(), _createBlock(_component_van_swipe_item, {
          key: "".concat(index, "-").concat(item),
          class: "swiper-item"
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("img", {
              src: item,
              alt: "\u8F6E\u64AD\u56FE".concat(index + 1),
              class: "swiper-image"
            }, null, 8, _hoisted_2)];
          }),
          _: 2
        }, 1024);
      }), 128))];
    }),
    _: 1
  }, 8, ["autoplay", "duration", "show-indicators", "indicator-color", "touchable", "onChange"])]);
}